import React, { useContext, useEffect, useState } from 'react';
// Contexts
import { SIGAMContext } from '~/contexts/SIGAMContext';
// Own Components
import Header from './components/Header';
import Content from './components/Content';
// Components
import Loading from '~/components/loading';
import UpdatePendingCard from '~/pages/SIGAM/components/Cards/UpdatePendingCard';
// Utils
import SocialMeAPI from '~/utils/SocialMeAPI';

export default function OrganizationalUnits() {
  const { activeInstitution } = useContext(SIGAMContext);
  const [loadingContent, setLoadingContent] = useState(true);
  const [searchInput, setSearchInput] = useState();
  const [organizationalUnits, setOrganizationalUnits] = useState();
  const [pageParameters, setPageParameters] = useState({
    currentPage: 1,
    totalElements: 0,
    limit: 10,
  });
  const [updatePending, setUpdatePending] = useState(false);

  async function GetDataAgain(newPageParameters) {
    setLoadingContent(true);
    const params = {
      operation: ['SIGAM', 'OrganizationalUnits', 'GetAll'],
      urlParams: {
        institutionId: activeInstitution.id,
      },
      data: {
        filter: {
          searchString: searchInput,
        },
        pagination: {
          limit: newPageParameters
            ? newPageParameters.limit
            : pageParameters.limit,
          page: newPageParameters
            ? newPageParameters.currentPage
            : pageParameters.currentPage,
          sort: {
            by: 'id',
            order: 'asc',
          },
        },
      },
    };
    const response = await SocialMeAPI(params);
    if (response.success) {
      setUpdatePending(false);
      setPageParameters({
        ...pageParameters,
        currentPage: response.body.orgUnities.currentPage,
        totalElements: response.body.orgUnities.totalElements,
        limit: response.body.orgUnities.limit,
      });
      setOrganizationalUnits(response.body.orgUnities.elements);
      setLoadingContent(false);
    }
  }

  useEffect(() => {
    async function GetOrganizationalUnits() {
      const params = {
        operation: ['SIGAM', 'OrganizationalUnits', 'GetAll'],
        urlParams: {
          institutionId: activeInstitution.id,
        },
        data: {
          filter: {
            searchString: searchInput,
          },
          pagination: {
            sort: {
              by: 'id',
              order: 'asc',
            },
          },
        },
      };
      const response = await SocialMeAPI(params);
      if (response.success) {
        setPageParameters({
          currentPage: response.body.orgUnities.currentPage,
          totalElements: response.body.orgUnities.totalElements,
          limit: response.body.orgUnities.limit,
        });
        setOrganizationalUnits(response.body.orgUnities.elements);
      }
      setLoadingContent(false);
    }
    GetOrganizationalUnits();
  }, [activeInstitution, searchInput]);

  return (
    <div>
      <Header
        GetDataAgain={GetDataAgain}
        setSearchInput={setSearchInput}
      />
      {loadingContent ? (
        <Loading text="Buscando Unidades Organizacionais" />
      ) : (
        <>
          <UpdatePendingCard
            GetDataAgain={GetDataAgain}
            updatePending={updatePending}
          />
          <Content
            data={organizationalUnits}
            pageParameters={pageParameters}
            GetDataAgain={GetDataAgain}
            setUpdatePending={setUpdatePending}
          />
        </>
      )}
    </div>
  );
}
